
import { CoreKeycloakConfig } from "@spike/core";

export const keycloakConfig: CoreKeycloakConfig = {
  config: {
    url: 'https://auth.spikebuild.com',
    realm: 'spike-users',
    clientId: 'spike-faggiotask-stage'
  },
  initOptions: {
    onLoad: 'login-required'
  }
};


export const baseUrl:string='https://api.spikebuild.com/api/faggiotask';